import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty, orderBy } from 'lodash'
import { Box, Button, Typography } from '@material-ui/core'
import { PlusCircle as PlusIcon } from 'react-feather'

import { useLocation, matchPath } from 'react-router-dom'

import { LoadingBox, Permitted } from 'components'
import { FragilityItem, FragilitiesDialog } from './components'

import qs from 'query-string'

import useFetch from 'hooks/useFetch'

import { routes } from 'Routes'

import * as service from 'service'
import constants from 'constants/index'

const Fragilities = ({ dataProcessId, onlyShow }) => {
  const [openNewFragility, setOpenNewFragility] = useState(false)

  const location = useLocation()
  const search = qs.parse(location.search)
  const isDataProcessShow = !!matchPath(location.pathname, {
    path: routes.dataProcess.view,
    exact: true,
  })

  const origin = search?.origin

  const isSuggestionOrigins = [
    constants.dataProcess.CARD_ORIGIN_DATA_PROCESS_SUGGESTION,
    constants.dataProcess.CARD_ORIGIN_DISCARDED,
  ].includes(origin)

  const showing = onlyShow || isSuggestionOrigins || isDataProcessShow

  const { response, isLoading, refresh } = useFetch(
    service.dponet.companyFragilities.getByDataProcess,
    { dataProcessId, origin },
    [isSuggestionOrigins],
    !isSuggestionOrigins,
  )

  const fragilities = response?.data?.companyFragilities

  return (
    <Box id={constants.dataProcess.DATA_PROCESS_EDIT_DRIVER_STEP_8} mt={2}>
      <Box
        mb={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h5">Ameaças</Typography>
        <Permitted tag={constants.permissions.DATA_PROCESSES.CREATE}>
          {!showing && (
            <Button
              id={constants.dataProcess.DATA_PROCESS_NEW_DRIVER_STEP_8}
              onClick={() => setOpenNewFragility(true)}
              startIcon={<PlusIcon />}
              variant="contained"
              color="primary"
            >
              Adicionar ameaça
            </Button>
          )}
        </Permitted>
      </Box>

      {isLoading && <LoadingBox minHeight={200} />}
      {!isLoading && isEmpty(fragilities) && (
        <Box pb={1}>
          <Typography variant="overline">
            Não foram encontradas ameaças para este processo
          </Typography>
        </Box>
      )}
      {orderBy(fragilities, 'isCompany').map((fragility) => (
        <FragilityItem
          key={fragility?.id}
          companyFragility={fragility}
          dataProcessId={dataProcessId}
          fragilityItems={fragility?.companyFragilityMeasures}
          refresh={refresh}
          onlyShow={showing}
        />
      ))}

      {!isLoading && openNewFragility && (
        <FragilitiesDialog
          dataProcessId={dataProcessId}
          defaultSelectedItems={fragilities}
          refresh={refresh}
          open={openNewFragility}
          setOpen={setOpenNewFragility}
        />
      )}
    </Box>
  )
}

Fragilities.propTypes = {
  dataProcessId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onlyShow: PropTypes.bool,
}

export default Fragilities
